import React from 'react'
import clsx from 'clsx'
import { useStyles } from './styles'

interface ImgWithFallbackProps {
    width?: number
    height?: number
    src: string
    alt?: string
    className?: string
    onLoad?: () => void
    onError?: () => void
    notFoundImage?: string
}

const ImgWithFallback: React.FC<ImgWithFallbackProps> = ({
    width,
    height,
    src,
    alt = '',
    className = '',
    onLoad,
    onError,
    notFoundImage,
}) => {
    const classes = useStyles({ notFoundImage })
    return (
        <img
            src={src}
            className={clsx(className, classes.root)}
            width={width}
            height={height}
            alt={alt}
            onLoad={event => {
                if (onLoad) onLoad()
                event?.currentTarget?.classList.add('loaded')
            }}
            onError={event => {
                if (onError) onError()
                event?.currentTarget?.classList.add('has-error')
                window.heap.track('404 Image Rendered')
            }}
        />
    )
}

export default React.memo(ImgWithFallback)
